exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba6-us-main-horizontal-line[data-v-76ed7913]{background-color:#c4d1e0;width:100%;height:1px}.ba6-info-section[data-v-76ed7913]{--builderall-icon-size:22px;--builderall-icon-color:#0072e1;padding:0 5px 6px 7px}.ba6-select[data-v-76ed7913]{height:42px}.ba6-p-element[data-v-76ed7913]{color:#4d5d71;font-size:12px;font-weight:500;letter-spacing:.66px}.ba6-input-file-box[data-v-76ed7913]{display:grid;grid-template-columns:1fr auto;gap:1rem}.ba6-input-file-box .ba6-label-file[data-v-76ed7913]{cursor:pointer;border-radius:6px;background:#eff2f8;margin:0;padding:9.6px 12.8px}.ba6-input-file-box .ba6-label-file span[data-v-76ed7913]{font-size:14px;font-weight:400}.ba6-input-file-box input[type=file][data-v-76ed7913]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76ed7913","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/account-settings/routes/Mailingboss.vue
// module id = mUny
// module chunks = 0